import { PaymentManager } from './PaymentManager';

export default PaymentManager;
